module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAY1BMVEUAAACwsLuprbiprbmqrbirrbmrr7mrr7qqrbmprbiorbiqrbeorbmprbmorbiorbeqr7msr7e2tsj///+rsbyprbj////Y2d2+wcmssLrd3uL6+vvKzNO4u8WwtL7i4+fIydEeni/CAAAAFXRSTlMAFv7vn3tiOdT35N3JrJCHdkcOAS4BZqydAAAAiElEQVQY00WP2QKCIBRER2TRNJeMK7jV/39lMmSdB86dufAAEk43ddmaApnH3WdKm3OVQljCeRqccB9XWaP3agQcbx8icpyuJmhPFlloh4aOYY8cBtR0EJk5dCjp7Sp6tPR8FRaGfn0LVaDgm32b38kagPV/bvyOUb/8BBkrRqXTnkxu6Hqb4wd3PQ+IP5rc6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = k3R8
// module chunks = 1